module.exports = __webpack_public_path__ + "static/media/15_r_vetka_80.52_68.89.dc37a9da.png";